import app from '../common_app.es6';

app.filter('trusted_html', ['$sce', ($sce) => (text) => $sce.trustAsHtml(text)])
